import { DefaultState } from '@src/redux/types'

import {
  JOB_POSITION_ACTIVATE,
  JOB_POSITION_ALL,
  JOB_POSITION_CREATE,
  JOB_POSITION_DELETE,
  JOB_POSITION_LIST,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [JOB_POSITION_ACTIVATE]: DefaultState<`${typeof API.JOB_POSITION_ACTIVATE}{id}`, 'put'>
  [JOB_POSITION_ALL]: DefaultState<`${typeof API.JOB_POSITION_ALL}`, 'get'>
  [JOB_POSITION_CREATE]: DefaultState<`${typeof API.JOB_POSITION}`, 'post'>
  [JOB_POSITION_DELETE]: DefaultState<`${typeof API.JOB_POSITION}{id}`, 'delete'>
  [JOB_POSITION_LIST]: DefaultState<`${typeof API.JOB_POSITION}`, 'get'>
} = () => ({
  [JOB_POSITION_ACTIVATE]: defaultState(),
  [JOB_POSITION_ALL]: defaultState(),
  [JOB_POSITION_CREATE]: defaultState(),
  [JOB_POSITION_DELETE]: defaultState(),
  [JOB_POSITION_LIST]: defaultState(),
})
